import {
  ApplicationConfig,
  EnvironmentInjector,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
  runInInjectionContext,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { loaderInterceptor } from './core/components/loader/loader.interceptor';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import {
  authInterceptor,
  blobInterceptor,
  errorInterceptor,
} from '@core/interceptors';
import { AuthService } from '@core/services';

function getRouterProviders() {
  return environment.isStandalonePortal
    ? provideRouter(routes)
    : provideRouter(routes, withHashLocation());
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    getRouterProviders(),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        loaderInterceptor,
        errorInterceptor,
        blobInterceptor,
      ]),
    ),
    provideAnimationsAsync(),
    provideHttpClient(),
    MessageService,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: 'none',
          cssLayer: {
            name: 'primeng',
            order: 'customPrimeflex, primeng, customPrimeng',
          },
        },
      },
    }),
    provideAppInitializer(() => {
      const injector = inject(EnvironmentInjector);

      return runInInjectionContext(injector, () => {
        const _authService = inject(AuthService);
        return Promise.resolve();
      });
    }),
  ],
};
